module.exports = __webpack_public_path__ + "img/Group 1745.0ffcd939.svg";